import _ from 'lodash';
import $ from "jquery";
import moment from 'moment';
import excelExport from 'table2excel/dist/table2excel';
import csvExport from 'table2csv/dist/table2csv';
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import FooTable from 'footable';

class IntegrationsController {
  constructor($rootScope, $http, AuthenticationService) {
    "ngInject";
    this.name = 'integrations';
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.auth = AuthenticationService;
  }
}

export default IntegrationsController;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/integrations.controller.js